module.exports = __webpack_public_path__ + "4a02fc158c61b9ab010f76bcb9f847e9.svg";